var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { FileMakerSearch } from '../FileMakerSearch';
import { DirectoryPlace } from '../../pages/directory-place';
export class FileMakerLists extends Component {
    constructor(isDebugEnabled = false) {
        super('FileMakerList', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if ($('.filemaker-list').data('model') != sessionStorage.getItem('list_type') && !$('body').hasClass('page-template-singles'))
                sessionStorage.removeItem('list_hash');
            $('.filemaker-list').each((element, index) => {
                FileMakerLists.lists.push(new FileMakerList(element, index === 0));
            });
            if ($('body').hasClass('page-template-month-shows') || $('body').hasClass('page-template-place-company') || $('body').hasClass('page-template-shows-theater') || $('body').hasClass('page-template-agenda-dynamic') || $('body').hasClass('page-template-directory_place') || $('body').hasClass('page-template-directory_producer')) {
                if (sessionStorage.getItem('list_hash'))
                    FileMakerLists.setHash(sessionStorage.getItem('list_hash'));
                if (location.hash !== '') {
                    const query = JSON.parse(decodeURIComponent(escape(atob(location.hash.substring(1)))));
                    console.log('FileMakerLists.init() - query', query);
                    FileMakerSearch.updateSearchFields(query);
                    FileMakerLists.reset(query);
                    FileMakerLists.load();
                }
            }
            this.success();
        });
    }
    static reset(query, index) {
        if (index !== undefined) {
            if (this.lists[index] !== undefined)
                this.lists[index].reset(query);
        }
        else {
            this.lists.forEach((list) => {
                if (!list.isMainList)
                    return;
                list.reset(query);
            });
        }
        //if (query['city']) query['city'] = query['city'].replace('~', '');
        if (index === undefined)
            FileMakerLists.setHash(btoa(unescape(encodeURIComponent((JSON.stringify(query))))));
    }
    static load(index) {
        if (index !== undefined) {
            if (this.lists[index] !== undefined)
                this.lists[index].load();
        }
        else {
            this.lists.forEach((list) => {
                if (!list.isMainList)
                    return;
                list.load();
            });
        }
    }
    static setHash(hash) {
        sessionStorage.setItem('list_hash', hash);
        sessionStorage.setItem('list_type', $('.filemaker-list').data('model'));
        if (history.pushState) {
            history.pushState(null, null, '#' + hash);
        }
        else {
            location.hash = '#' + hash;
        }
    }
}
FileMakerLists.lists = [];
class FileMakerList {
    constructor(listElement, isMainList) {
        this.isMainList = true;
        this.isActive = true;
        this.isLoading = false;
        this.isAllContentLoaded = false;
        this.isloadingDisabled = false;
        this.viewAsStructure = '';
        this.isMainList = isMainList;
        this.isActive = isMainList;
        this.listElement = listElement;
        if (this.listElement.length > 0) {
            this.model = this.listElement.data('model');
            this.order = {
                orderBy: this.listElement.data('orderBy'),
                order: this.listElement.data('order')
            };
            $(window).on('scroll', () => {
                if (!this.isActive)
                    return;
                const top = window.scrollY;
                const maxScroll = $('body').height() - $(window).height() - $('footer').height();
                if (top > maxScroll && !this.isloadingDisabled) {
                    this.load();
                }
            });
            this.reset();
            this.viewAsStructure = this.listElement.data('viewAsStructure') ? this.listElement.data('viewAsStructure') : '';
            if (this.listElement.data('autoload') === 'true')
                this.load();
        }
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isLoading || this.isAllContentLoaded)
                return;
            this.isLoading = true;
            this.isActive = true;
            $('#btn-search').addClass('disabled');
            this.addSpinner();
            let data = {
                'model': this.model,
                'range_skip': this.range.skip,
                'range_max': this.range.max,
                'order_by': this.order.orderBy,
                'order': this.order.order,
                'debug': location.href.includes('debug'),
                'test': location.href.includes('test'),
                'view_as_structure': this.viewAsStructure,
            };
            for (var key in this.query) {
                data['query[' + key + ']'] = this.query[key];
            }
            const response = yield $.httpRequest({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                body: Object.assign({
                    'action': 'fm_load_list',
                }, data),
                dataType: 'html',
            });
            this.listElement.append(response);
            const resultCountText = this.listElement.find('.result-count').text();
            this.listElement.parent().prev().find('.filemaker-list-count').text(resultCountText);
            if (parseInt(resultCountText) > 0)
                $('#btn-toggle-map').removeClass('d-none');
            if (this.listElement.find('.result').length >= parseInt(resultCountText))
                this.isAllContentLoaded = true;
            if (this.isAllContentLoaded && this.listElement.find('.result').length > 1)
                this.listElement.find('.no-results').remove();
            this.listElement.find('.result-count').remove();
            $('#btn-search').removeClass('disabled');
            this.removeSpinner();
            this.range.skip += this.range.max;
            this.isLoading = false;
            $('.general-count').text($('#tab-pane-general .filemaker-list-count').text());
            $('.proximity-count').text($('#tab-pane-proximity .filemaker-list-count').text());
            if (this.isMainList /*&& this.isAllContentLoaded*/ && this.query.city !== '' && this.query.region !== '' && this.model == 'show') {
                const proximityQuery = Object.assign({}, this.query);
                proximityQuery.city = '~' + proximityQuery.region;
                FileMakerLists.reset(proximityQuery, 1);
                FileMakerLists.load(1);
                $('.nav-tabs').removeClass('d-none');
                $('#tab-general').addClass('active');
                $('#tab-proximity').removeClass('active');
                $('#tab-pane-general').addClass('show active');
                $('#tab-pane-proximity').removeClass('show active');
                $('.list-header').addClass('d-none');
                $('.city-name').text(this.query.city);
                $('.region-name').text(this.query.region);
            }
            else if (this.isMainList) {
                $('.nav-tabs').addClass('d-none');
                $('.list-header').removeClass('d-none');
            }
            if (this.isMainList && this.model == 'place')
                DirectoryPlace.updatePlacesMarkers();
        });
    }
    reset(query) {
        this.range = { skip: 1, max: parseInt(this.listElement.data('max')) };
        this.query = query ? query : {};
        this.isAllContentLoaded = false;
        this.isActive = false;
        this.listElement.empty();
    }
    isQueryEmpty() {
        for (var key in this.query) {
            if (this.query[key] !== '')
                return false;
        }
        return true;
    }
    addSpinner() {
        this.listElement.append($.parseHTML('<div class="spinner-container py-48 d-flex justify-content-center"><div class="spinner-border" role="status"></div></div>'));
    }
    removeSpinner() {
        this.listElement.find('.spinner-container').remove();
    }
}
